<template>
  <div class="recruitApply">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <el-col :span="12"
            ><el-button
              size="small"
              icon="el-icon-download"
              @click="exportToExcel"
              v-access:modify
              >导出</el-button
            ></el-col
          >
          <el-col :span="12">
            <div class="search-box">
              <el-input
                class="toolBar-search"
                v-model="request.searchKey"
                placeholder="活动标题"
              />
              <el-button
                size="small"
                icon="el-icon-search"
                type="danger"
                @click="loadData(1)"
                >查询</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table
        :data="list"
        v-loading="loading"
        style="width: 100%"
        border
        :max-height="tableMaxHeight()"
      >
        <el-table-column
          prop="RecruitName"
          label="志愿活动"
          :show-overflow-tooltip="true"
        />
        <el-table-column label="活动时间" width="280">
          <template slot-scope="scope">
            {{ (scope.row.ActivityStartTime * 1000) | formatDate }}
            至
            {{ (scope.row.ActivityEndTime * 1000) | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="UserName" label="志愿者姓名" width="120">
          <template slot-scope="scope">
            <el-button
              v-access:read
              type="text"
              size="mini"
              @click="query(scope.row)"
              >{{ scope.row.UserName }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="Mobile" label="手机号码" width="120" />
        <el-table-column prop="ApplyTime" label="申请时间" width="140">
          <template slot-scope="scope">
            {{ (scope.row.ApplyTime * 1000) | formatDate }}
          </template>
        </el-table-column>
        <el-table-column prop="ApplyTime" label="服务工时" width="120">
          <template slot-scope="scope">
            {{ scope.row.Duration | duration2 }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <el-button
              v-access:read
              type="text"
              size="mini"
              @click="queryDetail(scope.row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wapper">
        <OfPagination
          :total="total"
          :pageSize="request.pageSize"
          :currentPage="request.pageIndex"
          @onSizeChange="handleSizeChange"
          @onCurrentChange="handleCurrentChange"
        ></OfPagination>
      </div>
    </BasePage>
    <volunteerBasicInfo
      :userId="userId"
      v-if="showVolunteer"
      @onCancel="onCancel"
    ></volunteerBasicInfo>
    <el-dialog
      el-dialog
      title="志愿者服务详情"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <div class="recruitApplyDetail">
        <el-row class="item-box">
          <el-col :span="8" class="item-label">志愿活动：</el-col>
          <el-col :span="16" class="item-value">{{
            recruitApplyDetail.RecruitName
          }}</el-col>
        </el-row>
        <el-row class="item-box">
          <el-col :span="8" class="item-label">志愿者名称：</el-col>
          <el-col :span="16" class="item-value">{{
            recruitApplyDetail.UserName
          }}</el-col>
        </el-row>
        <el-row class="item-box">
          <el-col :span="8" class="item-label">申请时间：</el-col>
          <el-col :span="16" class="item-value">{{
            (recruitApplyDetail.ApplyTime * 1000) | formatDate
          }}</el-col>
        </el-row>
        <el-row class="item-box">
          <el-col :span="8" class="item-label">服务工时：</el-col>
          <el-col :span="16" class="item-value">{{
            recruitApplyDetail.Duration | duration2
          }}</el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import BasePage from "@/components/base/of_page/of_page";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import api from "@/modules/zjrc/api";
import volunteerBasicInfo from "@/modules/zjrc/pages/volunteer/components/basicinfo/basicinfo.vue";
import { saveAs } from "file-saver";
export default {
  name: "recruitApply",
  data() {
    return {
      request: {
        pageIndex: 1,
        pageSize: 15,
        searchKey: "",
      },
      loading: false,
      list: [],
      total: 0,
      userId: "",
      showVolunteer: false,
      dialogVisible: false,
      recruitApplyDetail: {},
    };
  },
  components: {
    BasePage,
    OfPagination,
    volunteerBasicInfo,
  },
  mounted() {
    const vm = this;
    vm.loadData(1);
  },
  methods: {
    //导出到excel
    exportToExcel() {
      const vm = this;
      saveAs(
        "/api/VolunteerRecruitApply/ExportSign?searchKey=" +
          vm.request.searchKey,
        "志愿者签到名单.xls"
      );
    },
    queryDetail(row) {
      const vm = this;
      vm.recruitApplyDetail = row;
      vm.dialogVisible = true;
    },
    onCancel() {
      const vm = this;
      vm.showVolunteer = false;
    },
    query(row) {
      const vm = this;
      vm.userId = row.UserId;
      vm.showVolunteer = true;
    },
    loadData(pageIndex) {
      const vm = this;
      vm.request.pageIndex = pageIndex;
      vm.loading = true;
      api.QueryApplyVolunteerRecruit(vm.request).then((res) => {
        if (res.data.Code === 0) {
          vm.list = res.data.Data.rows;
          vm.total = res.data.Data.total;
          vm.loading = false;
        }
      });
    },
    handleCurrentChange(pageIndex) {
      const vm = this;
      if (vm.total > vm.request.pageSize) {
        vm.loadData(pageIndex);
      }
    },
    handleSizeChange(pageSize) {
      const vm = this;
      vm.request.pageSize = pageSize;
      vm.loadData(1);
    },
    //表格高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
  },
};
</script>
<style lang="scss" scoped>
.recruitApply {
  .search-box {
    text-align: right;
    .toolBar-search {
      width: 300px;
      padding-right: 20px;
    }
  }
  .recruitApplyDetail {
    .item-box {
      border-bottom: 1px dashed rgb(201, 198, 198);
      padding: 5px;
      .item-label {
        text-align: right;
      }
    }
  }
}
</style>